import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges
} from "@angular/core";
import { Nullable } from "src/app/support/nullable";
import { PageDetailHeaderActionComponent } from "./page-detail-header-action.component";
import { PageDetailHeaderBadgeComponent } from "./page-detail-header-badge.component";
import { PageDetailHeaderEmojiComponent } from "./page-detail-header-emoji.component";
import { PageDetailHeaderLine } from "./page-detail-header-line.component";
import { PageDetailHeaderLinkComponent } from "./page-detail-header-link.component";
import { PageDetailHeaderTagBoxComponent } from "./page-detail-header-tag-box.component";

export interface PageDetailHeaderAction {
  title: string;
  icon: string;
  onClick: () => void;
  disabled: boolean;
}

@Component({
  selector: "snoots-page-detail-header",
  template: "",
  standalone: false
})
export class PageDetailHeaderComponent implements OnChanges {
  @Input()
  title: string | null | undefined = "";

  @Input()
  preTitle: string | undefined;

  @Input()
  titleIcon: string | undefined;

  @Input()
  subHeader: string[] = [];

  @Output()
  titleChanged = new EventEmitter<string>();

  @Output()
  subHeaderChanged = new EventEmitter<string[]>();

  @ContentChildren(PageDetailHeaderLine)
  headerLines: Nullable<QueryList<PageDetailHeaderLine>> = null;

  @ContentChildren(PageDetailHeaderBadgeComponent)
  headerBadges: Nullable<QueryList<PageDetailHeaderBadgeComponent>> = null;

  @ContentChildren(PageDetailHeaderActionComponent)
  headerActions: Nullable<QueryList<PageDetailHeaderActionComponent>> = null;

  @ContentChildren(PageDetailHeaderLinkComponent)
  headerLinks: Nullable<QueryList<PageDetailHeaderLinkComponent>> = null;

  @ContentChild(PageDetailHeaderTagBoxComponent)
  tagBox: Nullable<PageDetailHeaderTagBoxComponent> = null;

  @ContentChild(PageDetailHeaderEmojiComponent)
  emoji: Nullable<PageDetailHeaderEmojiComponent> = null;

  emptyList: PageDetailHeaderAction[] = [];

  get actions(): PageDetailHeaderAction[] {
    return (
      this.headerActions?.map(
        (x) =>
          <PageDetailHeaderAction>{
            icon: x.icon,
            title: x.title,
            onClick: () => {
              x.onClick.emit();
            },
            disabled: x.disabled
          }
      ) || this.emptyList
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const titleChange = changes["title"];
    if (titleChange && !titleChange.firstChange) {
      this.titleChanged.emit(titleChange.currentValue);
    }

    const subHeaderChange = changes["subHeader"];
    if (subHeaderChange && !subHeaderChange.firstChange) {
      this.subHeaderChanged.emit(subHeaderChange.currentValue);
    }
  }
}
